// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserProfileContact, UserProfileContactSchema } from 'api/gen/UserProfileContact';

const requiredPart = t.interface({
  content: t.union([t.array(UserProfileContactSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserProfileContactSchema = excess(requiredPart);

export interface PagedModelUserProfileContact extends t.TypeOf<typeof PagedModelUserProfileContactSchema> {}
